(function () {
  function roundIn(cm) {
    return (cm / 2.54).toFixed(1);
  }

  function activateTab(root, tabName) {
    root.querySelectorAll('[data-size-chart-tab]').forEach(function (tab) {
      const active = tab.dataset.sizeChartTab === tabName;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-size-chart-panel]').forEach(function (panel) {
      const active = panel.dataset.sizeChartPanel === tabName;
      panel.classList.toggle('is-active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initChart(root) {
    if (!root || root.dataset.sizeChartInit === 'true') return;
    root.dataset.sizeChartInit = 'true';

    const unitButtons = root.querySelectorAll('[data-size-unit]');
    const measureCells = root.querySelectorAll('[data-cm]');
    const tabButtons = root.querySelectorAll('[data-size-chart-tab]');

    function setUnit(unit) {
      unitButtons.forEach(function (btn) {
        const active = btn.dataset.sizeUnit === unit;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      measureCells.forEach(function (cell) {
        const cm = parseFloat(cell.dataset.cm);
        if (Number.isNaN(cm)) return;
        cell.textContent = unit === 'in' ? roundIn(cm) : String(cm);
      });

      root.querySelectorAll('[data-unit-label]').forEach(function (label) {
        label.textContent = unit === 'in' ? 'IN' : 'CM';
      });
    }

    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setUnit(btn.dataset.sizeUnit);
      });
    });

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(root, btn.dataset.sizeChartTab);
      });
    });

    setUnit('cm');
    activateTab(root, 'measurements');
  }

  function initAll() {
    document.querySelectorAll('[data-size-chart-convertible]').forEach(initChart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-size-chart-popup]');
    if (!trigger) return;
    const popupId = trigger.getAttribute('data-size-chart-popup');
    const popup = document.getElementById(popupId);
    if (!popup) return;
    const chart = popup.querySelector('[data-size-chart-convertible]');
    if (chart) initChart(chart);
  });
})();
